import React, { Component } from 'react';
import Radium from 'radium';
import WMMenuItem from '@workmarket/front-end-components/dist/WMMenuItem';
import WMSvgIcon from '@workmarket/front-end-components/dist/WMSvgIcon';

class LeftNavMenuGroup extends Component {

	render() {
		const styles = {
			heading: {
				style: {
					marginTop:'18px',
					lineHeight: '24px',
					maxHeight: '24px',
					height: '24px',
					minHeight: '24px',
					color: 'rgba(0, 0, 0, 0.5)',
					fontSize: '1rem',
					fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
					fontWeight: 500,
					cursor: 'default',
					backgroundColor: 'transparent'
				},
				innerDivStyle: (href) => (
					location.pathname === href ?
						{
							padding: '0px 16px 0px 80px',
							fontSize: '.95rem',
							fontFamily: 'Open Sans',
							color: '#f7961d'
						} :
						{
							padding: '0px 16px 0px 80px',
							fontSize: '.95rem',
							fontFamily: 'Open Sans',
							color: '#8d9092'
						}
				),
				leftIconStyle: {
					marginTop: '0px',
					marginBottom: '0px',
					top: '1px',
					left: '8px'
				},
				longLabelDivStyle: {
					marginTop:'18px',
					lineHeight: '24px',
					maxHeight: '24px',
					height: '24px',
					minHeight: '38px',
					color: 'rgba(0, 0, 0, 0.5)',
					fontSize: '1rem',
					fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
					fontWeight: 500,
					cursor: 'pointer',
					backgroundColor: 'transparent',
					whiteSpace: 'pre-wrap'
				},
				longLabelIconStyle: {
					marginTop: '0px',
					marginBottom: '0px',
					top: '5px',
					left: '10px'
				}
			},
			list: {
				itemStyle: {
					lineHeight: '25px',
					maxHeight: '25px',
					height: '25px',
					minHeight: '25px',
					marginBottom: '5px',
				},
				innerDivStyle: (href)=> (
					location.pathname === href ?
					{
						fontFamily: 'Open Sans',
						fontSize: '1rem',
						color: '#f7961d',
						padding: '5px 16px 5px 80px'
					} :
					{
						fontFamily: 'Open Sans',
						fontSize: '.95rem',
						color: '#8d9092',
						padding: '5px 16px 5px 80px'
					}
				)
			}
		};

		if (this.props.navMenuItems.length < 1) {
			return <div> loading... </div>;
		}

		return (
			<div>{
				this.props.navMenuItems.map((el,index) => (
					el.style === undefined
						?
						<div key={index}>
							<WMMenuItem
								style={styles.heading.style}
								innerDivStyle={styles.heading.innerDivStyle(el.href)}
								href={el.href}
								disabled={true}
								leftIcon={
									<WMSvgIcon style={styles.heading.leftIconStyle} color="inherit">
										<path d={el.iconPath} fill="#8d9092" />
									</WMSvgIcon>
								}
								primaryText={el.label} />
							{
								el.items.map((item) => (
									<WMMenuItem
										style={styles.list.itemStyle}
										innerDivStyle={styles.list.innerDivStyle(item.href)}
										href={item.href}
										key={item.title}
										primaryText={item.title} />
								))
							}
						</div>
						:
						<a key={index} href={el.href}>
							<WMMenuItem
								style={styles.heading.longLabelDivStyle}
								innerDivStyle={styles.heading.innerDivStyle(el.href)}
								disabled={true}
								leftIcon={
									<WMSvgIcon style={styles.heading.longLabelIconStyle} color="inherit">
										<path d={el.iconPath} fill="#8d9092" />
									</WMSvgIcon>
								}
								primaryText={el.label} />
						</a>
					)
				)
			}
		</div>);
	}
}

export default LeftNavMenuGroup = Radium(LeftNavMenuGroup);
